<template>
  <el-table-column
    :align="column.align || 'center'"
    :fixed="column.fixed"
    :header-align="column.headerAlign || 'center'"
    :label="column.label"
    :min-width="column.minWidth"
    :prop="column.prop"
    :show-overflow-tooltip="column.overflowShowTooltip? true: false"
    :sortable="column.sortable ? 'custom' : false"
    :width="column.width">
    <template slot="header" slot-scope="scope">
      <my-dom v-if="column.is_header_custom" :render="column.header_slot"/>
      <span v-else>{{column.label}}</span>
    </template>

    <template v-if="column.children && column.children.length > 0">
      <mx-column v-for="(item, index2) in column.children" :column="item" :key="index2"></mx-column>
    </template>
    <template slot-scope="scope">
      <template v-if="!column.render">
        <template v-if="column.formatter">
          <span v-html="column.formatter(scope.row, column)"></span>
        </template>
        <template v-else>
          <span>{{scope.row[column.prop]}}</span>
        </template>
      </template>
      <template v-if="column.render">
        <expand-dom :column="column" :row="scope.row" :render="column.render"></expand-dom>
      </template>

      <!-- render button -->
      <template v-if="column.button">
        <template v-for="(btn, i) in column.group">
          <el-button
            v-if="btn.name"
            :key="i"
            :type="btn.type"
            :size="btn.size || 'mini'"
            :icon="btn.icon"
            :disabled="btn.disabled"
            :plain="btn.plain"
            :round="btn.round"
            :circle="btn.circle"
            :title="btn.title"
            @click.stop="btn.onClick(scope.row, scope.$index)"
          >{{ btn.name }}
          </el-button>
          <el-button
            v-else
            :key="i"
            :type="btn.type"
            :size="btn.size || 'mini'"
            :icon="btn.icon"
            :disabled="btn.disabled"
            :plain="btn.plain"
            :round="btn.round"
            :circle="btn.circle"
            :title="btn.title"
            @click.stop="btn.onClick(scope.row, scope.$index)"
          ></el-button>
        </template>
      </template>
    </template>
  </el-table-column>
</template>
<script>
export default {
  name: 'MxColumn',
  components: {
    myDom: {
      functional: true,
      props: {
        render: Function
      },
      render: (h, ctx) => {
        return ctx.props.render(h)
      }
    },
    expandDom: {
      functional: true,
      props: {
        row: Object,
        render: Function,
        index: Number,
        column: {
          type: Object,
          default: null
        }
      },
      render: (h, ctx) => {
        const params = {
          row: ctx.props.row,
          index: ctx.props.index
        }
        if (ctx.props.column) params.column = ctx.props.column
        return ctx.props.render(h, params)
      }
    }
  },
  props: {
    column: {
      type: Object
    }
  },
  mounted() {
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/Table/MxTable/column.vue